import { render, staticRenderFns } from "./redRainVerification.vue?vue&type=template&id=0fc0cd29"
import script from "./redRainVerification.vue?vue&type=script&lang=js"
export * from "./redRainVerification.vue?vue&type=script&lang=js"
import style0 from "./redRainVerification.vue?vue&type=style&index=0&id=0fc0cd29&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.29_css-loader@6.11.0_webpack@5.105.4__lodash@4_39ffd158bb5c9de026e694ab313270ab/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports